import { IDirective } from 'angular';

export function changeEventDirective(): IDirective {
  return {
    restrict: 'A',
    link: ( scope, element, attrs ) => {
      element.on('change', ( event ) => {
        const fn = scope.$eval(attrs.changeEvent);
        if ( typeof fn === 'function' ) {
          fn(event);
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/shared/directives/input-event/change-event.directive.ts